"use strict";exports.__esModule=true;exports.default=void 0;var _index=require("../../../lib/index.js");var _default=function _default(attr){var size=attr.patternSize+attr.patternDensity,color=(0,_index.hashify)(attr.color);return[{tagName:"rect",height:size,width:size,fill:attr.patternBgColor,opacity:attr.alpha/100},{tagName:"path",d:"M 0, "+size/2+" L "+size+", "+size/2,"stroke-width":attr.patternSize,stroke:_index.validhexcolor.test(color)?color:(0,_index.rgbaToHex)(attr.color),opacity:attr.patternAlpha/100}]};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/core/src/_internal/redraphael/pattern/line.js
// module id = g5h5
// module chunks = 5